import { render, staticRenderFns } from "./addWarehouse.vue?vue&type=template&id=2e864bf0"
import script from "./addWarehouse.vue?vue&type=script&lang=js"
export * from "./addWarehouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports